var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTspIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2189 12.9706V8.93351C30.2189 7.13859 28.7587 5.6783 26.9637 5.6783H22.6603V1H9.3401V5.6783H5.03667C3.24175 5.6783 1.78146 7.13859 1.78146 8.93351V12.9706H0.390625V14.7998H1.78146V21.7451C1.78146 23.54 3.24169 25.0003 5.03667 25.0003H26.9637C28.7587 25.0003 30.2189 23.54 30.2189 21.7451V14.7998H31.6098V12.9706H30.2189ZM11.1693 2.82925H20.831V5.6783H11.1693V2.82925ZM28.3897 21.745C28.3897 22.5313 27.75 23.171 26.9637 23.171H5.03667C4.25046 23.171 3.61071 22.5313 3.61071 21.745V14.7998H11.7251L12.71 19.1135H19.2903L20.2752 14.7998H28.3897V21.745ZM13.6014 14.7998H18.399L17.8317 17.2843H14.1687L13.6014 14.7998ZM28.3897 12.9706H3.61077V8.93351C3.61077 8.14724 4.25046 7.50755 5.03673 7.50755H26.9637C27.75 7.50755 28.3897 8.14724 28.3897 8.93351V12.9706Z",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTspIcon);
export default __webpack_public_path__ + "static/media/tsp_icon.3985624be93b1ea0ae3edf20bc855907.svg";
export { ForwardRef as ReactComponent };